module.exports = __webpack_public_path__ + "img/776.9bee5f5e.jpg";